import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Guardas
import { AuthGuard } from '@app/guards/auth.guard';

// Componentes
import { FormaDePagamentoListaComponent } from '@app/pages/configuracoes/forma-de-pagamento/forma-de-pagamento-lista/forma-de-pagamento-lista.component';
import { FormaDePagamentoFormComponent } from '@app/pages/configuracoes/forma-de-pagamento/forma-de-pagamento-form/forma-de-pagamento-form.component';
import { BancoListaComponent } from '@app/pages/configuracoes/banco/banco-lista/banco-lista.component';
import { BancoFormComponent } from '@app/pages/configuracoes/banco/banco-form/banco-form.component';
import { ContaListaComponent } from '@app/pages/configuracoes/conta/conta-lista/conta-lista.component';
import { ContaFormComponent } from '@app/pages/configuracoes/conta/conta-form/conta-form.component';
import { AtoProcessualListaComponent } from '@app/pages/configuracoes/ato-processual/ato-processual-lista/ato-processual-lista.component';
import { AtoProcessualFormComponent } from '@app/pages/configuracoes/ato-processual/ato-processual-form/ato-processual-form.component';
import { DocumentoListaComponent } from '@app/pages/configuracoes/documento/documento-lista/documento-lista.component';
import { DocumentoFormComponent } from '@app/pages/configuracoes/documento/documento-form/documento-form.component';
import { NaturezaDeAcaoListaComponent } from '@app/pages/configuracoes/natureza-de-acao/natureza-de-acao-lista/natureza-de-acao-lista.component';
import { NaturezaDeAcaoFormComponent } from '@app/pages/configuracoes/natureza-de-acao/natureza-de-acao-form/natureza-de-acao-form.component';
import { OrgaoDoJudiciarioListaComponent } from '@app/pages/configuracoes/orgao-do-judiciario/orgao-do-judiciario-lista/orgao-do-judiciario-lista.component';
import { OrgaoDoJudiciarioFormComponent } from '@app/pages/configuracoes/orgao-do-judiciario/orgao-do-judiciario-form/orgao-do-judiciario-form.component';
import { PedidoListaComponent } from '@app/pages/configuracoes/pedido/pedido-lista/pedido-lista.component';
import { PedidoFormComponent } from '@app/pages/configuracoes/pedido/pedido-form/pedido-form.component';
import { PosicaoDoClienteListaComponent } from '@app/pages/configuracoes/posicao-do-cliente/posicao-do-cliente-lista/posicao-do-cliente-lista.component';
import { PosicaoDoClienteFormComponent } from '@app/pages/configuracoes/posicao-do-cliente/posicao-do-cliente-form/posicao-do-cliente-form.component';
import { RitoListaComponent } from '@app/pages/configuracoes/rito/rito-lista/rito-lista.component';
import { RitoFormComponent } from '@app/pages/configuracoes/rito/rito-form/rito-form.component';
import { TipoDeAcaoListaComponent } from '@app/pages/configuracoes/tipo-de-acao/tipo-de-acao-lista/tipo-de-acao-lista.component';
import { TipoDeAcaoFormComponent } from '@app/pages/configuracoes/tipo-de-acao/tipo-de-acao-form/tipo-de-acao-form.component';
import { TipoDeJulgamentoListaComponent } from '@app/pages/configuracoes/tipo-de-julgamento/tipo-de-julgamento-lista/tipo-de-julgamento-lista.component';
import { TipoDeJulgamentoFormComponent } from '@app/pages/configuracoes/tipo-de-julgamento/tipo-de-julgamento-form/tipo-de-julgamento-form.component';
import { UnidadeListaComponent } from '@app/pages/configuracoes/unidade/unidade-lista/unidade-lista.component';
import { UnidadeFormComponent } from '@app/pages/configuracoes/unidade/unidade-form/unidade-form.component';
import { UsuarioTipoListaComponent } from '@app/pages/configuracoes/usuario-tipo/usuario-tipo-lista/usuario-tipo-lista.component';
import { UsuarioTipoFormComponent } from '@app/pages/configuracoes/usuario-tipo/usuario-tipo-form/usuario-tipo-form.component';
import { MeAviseTipoListaComponent } from '@app/pages/configuracoes/me-avise-tipo/me-avise-tipo-lista/me-avise-tipo-lista.component';
import { MeAviseTipoFormComponent } from '@app/pages/configuracoes/me-avise-tipo/me-avise-tipo-form/me-avise-tipo-form.component';
import { EntrevistaListaComponent } from '@app/pages/configuracoes/entrevista/entrevista-lista/entrevista-lista.component';
import { EntrevistaFormComponent } from '@app/pages/configuracoes/entrevista/entrevista-form/entrevista-form.component';
import { DemonstrativoResultadoComponent } from '@app/pages/configuracoes/demonstrativo-de-resultado/demonstrativo-de-resultado.component';
import { InstanciaFormComponent } from '@app/pages/configuracoes/instancia/instancia-form/instancia-form.component';
import { InstanciaListaComponent } from '@app/pages/configuracoes/instancia/instancia-lista/instancia-lista.component';

import { EstadoDoProcessoListaComponent } from '@app/pages/configuracoes/estado-do-processo/estado-do-processo-lista/estado-do-processo-lista.component';
import { EstadoDoProcessoFormComponent } from '@app/pages/configuracoes/estado-do-processo/estado-do-processo-form/estado-do-processo-form.component';
import { CidadeListaComponent } from '@app/pages/configuracoes/cidade/cidade-lista/cidade-lista.component';
import { CidadeFormComponent } from '@app/pages/configuracoes/cidade/cidade-form/cidade-form.component';

import { SubcategoriasFormComponent } from './subcategorias/subcategorias-form/subcategorias-form.component';
import { SubcategoriasListComponent } from './subcategorias/subcategorias-list/subcategorias-list.component';

import { MetaListaComponent } from './metas/meta-lista/meta-lista.component';
import { MetaFormComponent } from './metas/meta-form/meta-form.component';
import { AreaListaComponent } from './area/area-lista/area-lista.component';
import { AreaFormComponent } from './area/area-form/area-form.component';


const configuracoesRoutes: Routes = [
  { path: 'unidade', component: UnidadeListaComponent, canActivate: [AuthGuard] },
  { path: 'unidade/novo', component: UnidadeFormComponent, canActivate: [AuthGuard] },
  { path: 'unidade/editar/:id', component: UnidadeFormComponent, canActivate: [AuthGuard] },

  { path: 'area', component: AreaListaComponent, canActivate:[AuthGuard]},
  { path: 'area/novo', component: AreaFormComponent, canActivate:[AuthGuard]},
  { path: 'area/editar/:id', component: AreaFormComponent, canActivate:[AuthGuard]},

  { path: 'usuario-tipo', component: UsuarioTipoListaComponent, canActivate: [AuthGuard] },
  { path: 'usuario-tipo/novo', component: UsuarioTipoFormComponent, canActivate: [AuthGuard] },
  { path: 'usuario-tipo/editar/:id', component: UsuarioTipoFormComponent, canActivate: [AuthGuard] },

  { path: 'me-avise-tipo', component: MeAviseTipoListaComponent, canActivate: [AuthGuard] },
  { path: 'me-avise-tipo/novo', component: MeAviseTipoFormComponent, canActivate: [AuthGuard] },
  { path: 'me-avise-tipo/editar/:id', component: MeAviseTipoFormComponent, canActivate: [AuthGuard] },

  { path: 'cidade', component: CidadeListaComponent, canActivate: [AuthGuard] },
  { path: 'cidade/novo', component: CidadeFormComponent, canActivate: [AuthGuard] },
  { path: 'cidade/editar/:id', component: CidadeFormComponent, canActivate: [AuthGuard] },

  { path: 'forma-de-pagamento', component: FormaDePagamentoListaComponent, canActivate: [AuthGuard] },
  { path: 'forma-de-pagamento/novo', component: FormaDePagamentoFormComponent, canActivate: [AuthGuard] },
  { path: 'forma-de-pagamento/editar/:id', component: FormaDePagamentoFormComponent, canActivate: [AuthGuard] },

  { path: 'banco', component: BancoListaComponent, canActivate: [AuthGuard] },
  { path: 'banco/novo', component: BancoFormComponent, canActivate: [AuthGuard] },
  { path: 'banco/editar/:id', component: BancoFormComponent, canActivate: [AuthGuard] },

  { path: 'conta', component: ContaListaComponent, canActivate: [AuthGuard] },
  { path: 'conta/novo', component: ContaFormComponent, canActivate: [AuthGuard] },
  { path: 'conta/editar/:id', component: ContaFormComponent, canActivate: [AuthGuard] },

  { path: 'ato-processual', component: AtoProcessualListaComponent, canActivate: [AuthGuard] },
  { path: 'ato-processual/novo', component: AtoProcessualFormComponent, canActivate: [AuthGuard] },
  { path: 'ato-processual/editar/:id', component: AtoProcessualFormComponent, canActivate: [AuthGuard] },

  { path: 'documento', component: DocumentoListaComponent, canActivate: [AuthGuard] },
  { path: 'documento/novo', component: DocumentoFormComponent, canActivate: [AuthGuard] },
  { path: 'documento/editar/:id', component: DocumentoFormComponent, canActivate: [AuthGuard] },

  { path: 'subcategoria', component: SubcategoriasListComponent, canActivate: [AuthGuard] },
  { path: 'subcategoria/novo', component: SubcategoriasFormComponent, canActivate: [AuthGuard] },
  { path: 'subcategoria/editar/:id', component: SubcategoriasFormComponent, canActivate: [AuthGuard] },

  { path: 'entrevista', component: EntrevistaListaComponent, canActivate: [AuthGuard] },
  { path: 'entrevista/novo', component: EntrevistaFormComponent, canActivate: [AuthGuard] },
  { path: 'entrevista/editar/:id', component: EntrevistaFormComponent, canActivate: [AuthGuard] },

  { path: 'estado-do-processo', component: EstadoDoProcessoListaComponent, canActivate: [AuthGuard] },
  { path: 'estado-do-processo/novo', component: EstadoDoProcessoFormComponent, canActivate: [AuthGuard] },
  { path: 'estado-do-processo/editar/:id', component: EstadoDoProcessoFormComponent, canActivate: [AuthGuard] },

  { path: 'natureza-de-acao', component: NaturezaDeAcaoListaComponent, canActivate: [AuthGuard] },
  { path: 'natureza-de-acao/novo', component: NaturezaDeAcaoFormComponent, canActivate: [AuthGuard] },
  { path: 'natureza-de-acao/editar/:id', component: NaturezaDeAcaoFormComponent, canActivate: [AuthGuard] },

  { path: 'orgao-do-judiciario', component: OrgaoDoJudiciarioListaComponent, canActivate: [AuthGuard] },
  { path: 'orgao-do-judiciario/novo', component: OrgaoDoJudiciarioFormComponent, canActivate: [AuthGuard] },
  { path: 'orgao-do-judiciario/editar/:id', component: OrgaoDoJudiciarioFormComponent, canActivate: [AuthGuard] },

  { path: 'pedido', component: PedidoListaComponent, canActivate: [AuthGuard] },
  { path: 'pedido/novo', component: PedidoFormComponent, canActivate: [AuthGuard] },
  { path: 'pedido/editar/:id', component: PedidoFormComponent, canActivate: [AuthGuard] },

  { path: 'posicao-do-cliente', component: PosicaoDoClienteListaComponent, canActivate: [AuthGuard] },
  { path: 'posicao-do-cliente/novo', component: PosicaoDoClienteFormComponent, canActivate: [AuthGuard] },
  { path: 'posicao-do-cliente/editar/:id', component: PosicaoDoClienteFormComponent, canActivate: [AuthGuard] },

  { path: 'rito', component: RitoListaComponent, canActivate: [AuthGuard] },
  { path: 'rito/novo', component: RitoFormComponent, canActivate: [AuthGuard] },
  { path: 'rito/editar/:id', component: RitoFormComponent, canActivate: [AuthGuard] },

  { path: 'tipo-de-acao', component: TipoDeAcaoListaComponent, canActivate: [AuthGuard] },
  { path: 'tipo-de-acao/novo', component: TipoDeAcaoFormComponent, canActivate: [AuthGuard] },
  { path: 'tipo-de-acao/editar/:id', component: TipoDeAcaoFormComponent, canActivate: [AuthGuard] },

  { path: 'tipo-de-julgamento', component: TipoDeJulgamentoListaComponent, canActivate: [AuthGuard] },
  { path: 'tipo-de-julgamento/novo', component: TipoDeJulgamentoFormComponent, canActivate: [AuthGuard] },
  { path: 'tipo-de-julgamento/editar/:id', component: TipoDeJulgamentoFormComponent, canActivate: [AuthGuard] },

  { path: 'instancia', component: InstanciaListaComponent, canActivate: [AuthGuard] },
  { path: 'instancia/novo', component: InstanciaFormComponent, canActivate: [AuthGuard] },
  { path: 'instancia/editar/:id', component: InstanciaFormComponent, canActivate: [AuthGuard] },

  { path: 'demonstrativo-de-resultado', component: DemonstrativoResultadoComponent, canActivate: [AuthGuard] },

  { path: 'metas', component: MetaListaComponent, canActivate: [AuthGuard] },
  { path: 'metas/nova', component: MetaFormComponent, canActivate: [AuthGuard] }

];

@NgModule({
  imports: [RouterModule.forChild(configuracoesRoutes)],
  exports: [RouterModule]
})
export class ConfiguracoesRoutingModule { }
